import React, { useCallback, useEffect, useState } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import NavItem from '../../components/NavItem';
import { FaSave, FaArrowLeft } from 'react-icons/fa';
import api from '../../services/api';
import { toast } from 'react-toastify';
import Select from 'react-select';
import SaveButton from '../../components/SaveButton';

export default function ConfiguracaoOrcamentoModelo() {
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem('empresa');
    const [itensPermanentes, setItensPermanentes] = useState([]);
    const [itensPermanentesInternacionais, setItensPermanentesInternacionais] = useState([]);
    const [opcoesItens, setOpcoesItens] = useState([]);
    const [carregando, setCarregando] = useState(false);
    const [salvando, setSalvando] = useState(false);

    const carregarDados = useCallback(async () => {
        setCarregando(true);
        try {
            // Primeiro carrega opções de itens (sem filtro de superior para mostrar todos)
            const itensResponse = await api({
                method: 'get',
                action: '/empresaConfiguracao/itensOrcamento',
                token,
                params: {
                    superior: '' // Deixa em branco para mostrar todos
                }
            });

            let itensFormatados = [];
            if (itensResponse.data && itensResponse.data.data) {
                itensFormatados = itensResponse.data.data.map(item => ({
                    value: item.id,
                    label: item.label
                }));
                setOpcoesItens(itensFormatados);
            }

            // Depois carrega configuração atual e mapeia os IDs para os objetos do react-select
            const configResponse = await api({
                method: 'get',
                action: '/empresaConfiguracao',
                token,
                params: {
                    empresa: empresa
                }
            });

            if (configResponse.data && configResponse.data.data) {
                const config = configResponse.data.data;
                // Converte arrays de IDs para formato do react-select
                const itensPermanentesFormatados = (config.itensPermanentes || []).map(id => {
                    const item = itensFormatados.find(opt => opt.value === id);
                    return item || { value: id, label: `Item #${id}` };
                });
                const itensInternacionaisFormatados = (config.itensPermanentesInternacionais || []).map(id => {
                    const item = itensFormatados.find(opt => opt.value === id);
                    return item || { value: id, label: `Item #${id}` };
                });
                
                setItensPermanentes(itensPermanentesFormatados);
                setItensPermanentesInternacionais(itensInternacionaisFormatados);
            }
        } catch (error) {
            toast.error('Erro ao carregar configurações: ' + (error.response?.data?.error ?? 'Erro desconhecido'));
        } finally {
            setCarregando(false);
        }
    }, [empresa, token]);

    useEffect(() => {
        carregarDados();
    }, [carregarDados]);

    const salvar = async () => {
        setSalvando(true);
        try {
            await api({
                method: 'put',
                action: '/empresaConfiguracao',
                token,
                data: {
                    empresa: empresa,
                    itensPermanentes: itensPermanentes.map(item => item.value || item),
                    itensPermanentesInternacionais: itensPermanentesInternacionais.map(item => item.value || item)
                }
            });

            toast.success('Configurações salvas com sucesso!');
        } catch (error) {
            toast.error('Erro ao salvar configurações: ' + (error.response?.data?.error ?? 'Erro desconhecido'));
        } finally {
            setSalvando(false);
        }
    };

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <ul className="nav">
                    <NavItem to="/orcamentoModelo" icon={<FaArrowLeft size={20} />} color="secondary">Voltar</NavItem>
                </ul>
                <div className="page-title">
                    <h3>Configurações de Orçamento Modelo</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                                        {carregando ? (
                                            <div className="text-center p-4">
                                                <div className="spinner-border" role="status">
                                                    <span className="sr-only">Carregando...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                <div className="row mb-4">
                                                    <div className="col-sm-12">
                                                        <h5>Itens Permanentes</h5>
                                                        <p className="text-muted">Selecione os itens e subitens que devem aparecer permanentemente nos orçamentos.</p>
                                                        <div className="form-group">
                                                            <label>Itens Permanentes</label>
                                                            <Select
                                                                isMulti
                                                                options={opcoesItens}
                                                                value={itensPermanentes}
                                                                onChange={setItensPermanentes}
                                                                placeholder="Selecione os itens permanentes..."
                                                                isSearchable
                                                                isLoading={carregando}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <h5>Itens Permanentes (Eventos Internacionais)</h5>
                                                        <p className="text-muted">Selecione os itens e subitens que devem aparecer permanentemente nos orçamentos de eventos internacionais.</p>
                                                        <div className="form-group">
                                                            <label>Itens Permanentes (Eventos Internacionais)</label>
                                                            <Select
                                                                isMulti
                                                                options={opcoesItens}
                                                                value={itensPermanentesInternacionais}
                                                                onChange={setItensPermanentesInternacionais}
                                                                placeholder="Selecione os itens permanentes para eventos internacionais..."
                                                                isSearchable
                                                                isLoading={carregando}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="row fixoRodape">
                    <div className="col-12 d-flex justify-content-end">
                        <SaveButton type="button" isSubmitting={salvando} onClick={salvar} />
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}

